export const NONE_CHANGED_APP_INSTANCES = 'none-changed'
